export const VALIDATION_RULE = {
  required: 'required',
  maxLength: 'max_length',
  minLength: 'min_length',
  isUrl: 'is_url',
  isEmail: 'is_email',
  password: 'password',
  oneComma: 'one_comma',
};
export type ValidationRule = (typeof VALIDATION_RULE)[keyof typeof VALIDATION_RULE];
